import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Routes } from '../../../config/routes';
import Button, { ButtonStyle } from './Button';
import ButtonContainer from './ButtonContainer';

export default function SupportButton(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleButtonClick = () => {
    navigate(Routes.SUPPORT, { state: { from: location.pathname } });
  };

  return (
    <ButtonContainer bottomMargin="mb-0">
      <Button
        style={ButtonStyle.INVERTED}
        disabled={false}
        onClick={handleButtonClick}
        dataTestid="CONTACT_SUPPORT_BUTTON"
      >
        <span>{t('screens.support.contactButtonLabel')}</span>
      </Button>
    </ButtonContainer>
  );
}
